import { Metric } from '../../constants/Types';

type PayloadPoint = {
  present_value?: number | string | null,
};

const getNumericValue = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim().length > 0) {
    const parsedValue = Number(value);
    if (Number.isFinite(parsedValue)) return parsedValue;
  }
  return null;
};

const roundMetricValue = (value: number): number => Math.round(value * 100) / 100;

const pointToAssetField: Record<string, string> = {
  [Metric.TEMPERATURE]: 'temp',
  [Metric.HUMIDITY]: 'humidity',
  [Metric.CO2]: 'co2',
  [Metric.TVOC]: 'tvoc',
  [Metric.PM10]: 'pm10',
  [Metric.PM25]: 'pm25',
  [Metric.NOISE]: 'spl',
  [Metric.LIGHT]: 'lux',
};

const hydrateSensorMetricsFromPayload = (asset: any): boolean => {
  const points: Record<string, PayloadPoint> | undefined = asset?.lastDevicePayload?.data?.points;
  if (!points) return false;

  let hasAtLeastOneValue = false;
  Object.entries(pointToAssetField).forEach(([pointName, fieldName]) => {
    const value = getNumericValue(points[pointName]?.present_value);
    if (value === null) {
      asset[fieldName] = 0;
      return;
    }
    asset[fieldName] = roundMetricValue(value);
    hasAtLeastOneValue = true;
  });

  const payloadTimestamp = asset?.lastDevicePayload?.data?.timestamp;
  if (typeof payloadTimestamp === 'string' && payloadTimestamp.length > 0) {
    asset.timestamp = payloadTimestamp;
  }

  return hasAtLeastOneValue;
};

export default hydrateSensorMetricsFromPayload;
